import { useState } from "react";

const faqs = [
  {
    q: "Ile trwa realizacja strony?",
    a: "Zazwyczaj 3–5 dni roboczych od momentu zebrania materiałów. W przypadku rozbudowanych stron z dużą ilością treści może to być 7–10 dni. Zawsze ustalam termin przed rozpoczęciem pracy.",
  },
  {
    q: "Czy muszę dostarczyć zdjęcia?",
    a: "Nie jest to konieczne. Jeśli masz zdjęcia swoich realizacji — super, wykorzystam je na stronie. Jeśli nie, mogę użyć profesjonalnych zdjęć stockowych dopasowanych do Twojej branży.",
  },
  {
    q: "Kto napisze teksty na stronę?",
    a: "W pakiecie Firma i Pro przygotowuję teksty na podstawie krótkiej rozmowy. W pakiecie Start możesz dostarczyć własne opisy lub skorzystać z gotowych propozycji.",
  },
  {
    q: "Czy strona będzie dobrze wyglądać na telefonie?",
    a: "Tak, każda strona jest projektowana tak, żeby działała i wyglądała dobrze na telefonach, tabletach i komputerach. Mobile-first to podstawa.",
  },
  {
    q: "Czy po wdrożeniu mogę wprowadzać zmiany?",
    a: "Tak. Po oddaniu strony możliwe są poprawki. Oferuję też wsparcie techniczne i możliwość dalszej współpracy przy aktualizacjach treści.",
  },
  {
    q: "Czy strona pomoże mi zdobywać klientów?",
    a: "Strona to narzędzie — musi być dobrze zbudowana, żeby działała. Projektuję strony pod lokalne SEO i konwersję, co oznacza więcej wejść z Google i więcej klientów decydujących się na kontakt. To nie jest gwarancja, ale moje strony są tworzone z konkretnym celem: więcej telefonów i zapytań.",
  },
  {
    q: "Czy mogę zobaczyć efekty pracy przed podjęciem decyzji?",
    a: "Tak. Możemy porozmawiać o Twojej firmie, a ja pokażę przykłady stron dla podobnych branż. Bezpłatna konsultacja jest po to, żebyś mógł ocenić, czy to rozwiązanie dla Ciebie.",
  },
];

const FAQSection = () => {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">
            FAQ
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1A1A2E] mb-5">
            Najczęstsze pytania
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed">
            Odpowiedzi na pytania, które słyszę najczęściej przed rozpoczęciem współpracy.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <article
              key={i}
              className="border border-gray-100 rounded-xl overflow-hidden"
              itemScope
              itemType="https://schema.org/Question"
            >
              <h4 id={`faq-${i}`} className="m-0">
                <a href={`#faq-${i}`} className="contents">
                  <button
                    onClick={() => setOpen(open === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-[#F7F8FA] transition-colors"
                    aria-expanded={open === i}
                  >
                    <span className="font-semibold text-[#1A1A2E] text-sm lg:text-base pr-4" itemProp="name">
                      {faq.q}
                    </span>
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i
                        className={`${
                          open === i ? "ri-subtract-line" : "ri-add-line"
                        } text-[#0F2557] text-lg transition-transform`}
                      ></i>
                    </div>
                  </button>
                </a>
              </h4>
              {open === i && (
                <div className="px-6 pb-5" itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-100 pt-4" itemProp="text">
                    {faq.a}
                  </p>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
